// Minimal multi-coloured G mark in an inline SVG used inside dark CTA buttons.
export default function GoogleGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      className="w-5 h-5"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6 12.227c0-.708-.064-1.39-.182-2.045H12v3.868h5.382a4.6 4.6 0 0 1-1.995 3.018v2.51h3.227c1.887-1.736 2.986-4.293 2.986-7.351z"
        fill="#fff"
      />
      <path
        d="M12 22c2.7 0 4.964-.895 6.614-2.422l-3.227-2.51c-.895.6-2.04.955-3.387.955-2.605 0-4.81-1.758-5.598-4.122H3.073v2.59A9.997 9.997 0 0 0 12 22z"
        fill="#fff"
        opacity="0.9"
      />
      <path
        d="M6.402 13.901a6.011 6.011 0 0 1 0-3.802V7.509H3.073a10.004 10.004 0 0 0 0 8.982l3.329-2.59z"
        fill="#fff"
        opacity="0.75"
      />
      <path
        d="M12 5.977c1.468 0 2.786.505 3.823 1.495l2.867-2.866C16.96 2.998 14.696 2 12 2A9.997 9.997 0 0 0 3.073 7.509l3.329 2.59C7.19 7.735 9.395 5.977 12 5.977z"
        fill="#fff"
        opacity="0.6"
      />
    </svg>
  );
}
